<button [type]="type" (click)="onClick($event)">
  {{ label }}
</button>
